import {
  HomeOutlined as HomeOutlinedIcon,
  PeopleOutlined as PeopleOutlinedIcon,
  FeedOutlined as FeedOutlinedIcon,
  LiveHelpOutlined as LiveHelpOutlinedIcon,
  CalculateOutlined as CalculateOutlinedIcon,
} from "@mui/icons-material";
import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  SvgIcon,
} from "@mui/material";
import { useIsInQuickLink, useIsInstitutionalUser, useIsMobile, useNavigate } from "../utils/hooks";
import _ from "lodash";
import { useAuth } from "../auth/context";

const allPages = [
  { name: "Inicio", path: "/", icon: <HomeOutlinedIcon /> },
  {
    name: "Pacientes",
    path: "/patients",
    inQuickLink: true,
    icon: <PeopleOutlinedIcon />,
  },
  {
    name: "Prescripciones",
    path: "/prescriptions",
    inQuickLink: true,
    icon: <FeedOutlinedIcon />,
  },
  { name: "Calculadoras", path: "/calculators", icon: <CalculateOutlinedIcon /> },
  {
    name: "Soporte",
    path: "whatsapp",
    icon: <LiveHelpOutlinedIcon />,
  },
];
const usePages = () => {
  const isInQuickLink = useIsInQuickLink();
  const isInstitutionalUser = useIsInstitutionalUser();

  const basePages = isInQuickLink
    ? _.filter(allPages, "inQuickLink")
    : allPages;

  return isInstitutionalUser
    ? _.filter(basePages, (page) => page.path !== "whatsapp")
    : basePages;
  };
  export default function ListNavegation({ handleDrawerToggle }) {
  const isMobile = useIsMobile();
  const pages = usePages();
  const navigation = useNavigate();
  const { user } = useAuth();

  const handleToPath = (path) => {
    if (path === "whatsapp") {
      window.open(
        `https://api.whatsapp.com/send/?phone=5491123989455&text=Hola, tengo una consulta. ID de usuario ${user.id}&type=phone_number&app_absent=0`,
        "_blank"
      );
    } else {
      isMobile && handleDrawerToggle();
      navigation(path);
    }
  };

  return (
    <List sx={{ pt: 0, pb: 0 }}>
      {pages.map(({ name, path, icon }, index) => (
        <Box key={name}>
          <ListItemButton
            onClick={() => handleToPath(path)}
            sx={{
              borderRadius: 2,
              "& .MuiSvgIcon-root": {
                color: index >= 3 ? "grey.main" : "secondary.main",
              },
              "& .MuiTypography-root": {
                color: index >= 3 ? "grey.main" : "secondary.main",
              },
              "&:hover": {
                bgcolor: "#D3E9FB",
                "& .MuiSvgIcon-root": {
                  color: "primary.main",
                },
                "& .MuiTypography-root": {
                  color: "primary.main",
                },
              },
            }}
          >
            <ListItemText
              primary={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <SvgIcon sx={{ fontSize: 22 }}>{icon}</SvgIcon>
                  <Typography variant="body2" sx={{ ml: 2 }}>
                    {name}
                  </Typography>
                </Box>
              }
            />
          </ListItemButton>
          {index === 2 && <Divider sx={{ m: 2 }} />}
        </Box>
      ))}
    </List>
  );
}
